<wl-content-section [id]="id()" [theme]="theme()">
  <wl-reviews-entry-section
    [reviews]="reviews()"
    [title]="title()"
    [button]="button()"
    [showSummaryOnly]="showSummaryOnly()"
  />
</wl-content-section>
